/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Sign_InInputs */

const en_check_in_sign_in = /** @type {(inputs: Check_In_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to start check-in`)
};

const es_check_in_sign_in = /** @type {(inputs: Check_In_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesion para registrarte`)
};

/**
* | output |
* | --- |
* | "Sign in to start check-in" |
*
* @param {Check_In_Sign_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_sign_in = /** @type {((inputs?: Check_In_Sign_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Sign_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_sign_in(inputs)
	return es_check_in_sign_in(inputs)
});